import React, { useState, useEffect } from 'react';
import { getPublicTestimonials } from '../services/api';

const Testimonials = () => {
  const [testimonials, setTestimonials] = useState([]);
  const [loading, setLoading] = useState(true);
  const [stats, setStats] = useState({
    satisfaction: '98%',
    projects: '500+',
    continents: '6',
    repeatBusiness: '95%'
  });

  useEffect(() => {
    fetchTestimonials();
  }, []);

  const fetchTestimonials = async () => {
    try {
      const response = await getPublicTestimonials();
      console.log('Testimonials API Response:', response);
      
      // Extract testimonials data from response
      let testimonialsData = [];
      
      if (response && response.data && Array.isArray(response.data)) {
        testimonialsData = response.data;
      } else if (response && Array.isArray(response)) {
        testimonialsData = response;
      } else if (response && response.testimonials && Array.isArray(response.testimonials)) {
        testimonialsData = response.testimonials;
      }
      
      // Filter active testimonials and sort by order
      const activeTestimonials = testimonialsData
        .filter(t => t.isActive !== false)
        .sort((a, b) => (a.order || 0) - (b.order || 0));
      
      setTestimonials(activeTestimonials);
      console.log('Testimonials loaded:', activeTestimonials.length);
      
    } catch (error) {
      console.error('Error fetching testimonials:', error);
    } finally {
      setLoading(false);
    }
  };

  const getFullImageUrl = (url) => {
    if (!url) return '';
    if (url.startsWith('http')) return url;
    if (url.startsWith('/uploads')) return `https://inteliheads.in${url}`;
    return url;
  };

  const renderStars = (rating) => {
    const stars = [];
    const fullStars = Math.floor(rating || 5);
    const hasHalfStar = (rating % 1) !== 0;
    
    for (let i = 0; i < fullStars; i++) {
      stars.push(<i key={i} className="fas fa-star" style={{ fontSize: '0.8rem', color: '#F5A623' }}></i>);
    }
    if (hasHalfStar) {
      stars.push(<i key="half" className="fas fa-star-half-alt" style={{ fontSize: '0.8rem', color: '#F5A623' }}></i>);
    }
    const remainingStars = 5 - Math.ceil(rating || 5);
    for (let i = 0; i < remainingStars; i++) {
      stars.push(<i key={`empty-${i}`} className="far fa-star" style={{ fontSize: '0.8rem', color: '#CBD5E1' }}></i>);
    }
    return stars;
  };

  const getInitials = (name) => {
    if (!name) return 'U';
    return name.charAt(0).toUpperCase();
  };

  const getCategoryColor = (category) => {
    const colors = {
      'Enterprise': '#2C7A7B',
      'SMB': '#F5A623',
      'Technology': '#3498db',
      'Education': '#9b59b6',
      'Government': '#e74c3c'
    };
    return colors[category] || '#2C7A7B';
  };

  if (loading) {
    return (
      <section id="testimonials" style={{ padding: '5rem 0', background: '#F7F9FC', textAlign: 'center' }}>
        <div className="container">
          <i className="fas fa-spinner fa-spin" style={{ fontSize: '2rem', color: '#2C7A7B' }}></i>
          <p style={{ marginTop: '1rem', color: '#5A6E7F' }}>Loading testimonials...</p>
        </div>
      </section>
    );
  }

  // Use default testimonials if no data from database
  const displayTestimonials = testimonials.length > 0 ? testimonials : [
    {
      _id: 'default1',
      name: 'Klaus Richter',
      position: 'Chief Grid Officer',
      company: 'E.ON',
      content: 'INTELIHEADS INTERNET Pvt. Ltd transformed our grid analysis capabilities. Their PowerFactory expertise and implementation support reduced our system downtime by 40%. The team\'s technical knowledge is truly world-class.',
      rating: 5,
      avatar: null
    },
    {
      _id: 'default2',
      name: 'Dr. Vikram Patel',
      position: 'Director of Engineering',
      company: 'Tata Power',
      content: 'The training programs from INTELIHEADS helped our engineering team master MATLAB & Simulink in record time. Highly professional, well-structured curriculum, and excellent post-training support.',
      rating: 5,
      avatar: null
    },
    {
      _id: 'default3',
      name: 'Jennifer Chen',
      position: 'VP Engineering',
      company: 'Boeing',
      content: 'Their Ansys multiphysics simulation services accelerated our product development cycle by 40%. The team\'s attention to detail and commitment to deadlines made them an invaluable partner.',
      rating: 5,
      avatar: null
    }
  ];

  return (
    <section id="testimonials" style={{ padding: '5rem 0', background: '#F7F9FC' }}>
      <div className="container">
        <div style={{ textAlign: 'center', marginBottom: '3rem' }}>
          <h2 style={{ fontSize: 'clamp(1.6rem, 6vw, 2.25rem)', marginBottom: '1rem', color: '#0A192F' }}>
            What Our Clients Say
          </h2>
          <div style={{ fontSize: 'clamp(0.9rem, 4vw, 1.125rem)', color: '#5A6E7F' }}>
            Trusted by leading organizations across 6 continents
          </div>
        </div>
        
        {displayTestimonials.length === 0 ? (
          <div style={{ textAlign: 'center', padding: '3rem', background: 'white', borderRadius: '20px' }}>
            <i className="fas fa-comment" style={{ fontSize: '3rem', color: '#CBD5E1', marginBottom: '1rem' }}></i>
            <p style={{ color: '#5A6E7F' }}>No testimonials available at the moment.</p>
          </div>
        ) : (
          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(350px, 1fr))',
            gap: '2rem'
          }}>
            {displayTestimonials.map((testimonial, index) => (
              <div
                key={testimonial._id || index}
                data-aos="fade-up"
                data-aos-delay={index * 100}
                style={{
                  background: 'white',
                  borderRadius: '20px',
                  padding: '2rem',
                  boxShadow: '0 20px 25px -12px rgba(0,0,0,0.08)',
                  border: '1px solid #E2E8F0',
                  position: 'relative',
                  transition: 'all 0.3s ease',
                  height: '100%',
                  display: 'flex',
                  flexDirection: 'column'
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'translateY(-8px)';
                  e.currentTarget.style.borderColor = '#2C7A7B';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.borderColor = '#E2E8F0';
                }}
              >
                {/* Quote Icon */}
                <div style={{
                  fontSize: '2.5rem',
                  color: '#4A9D9E',
                  opacity: 0.3,
                  position: 'absolute',
                  top: '1.5rem',
                  right: '1.5rem'
                }}>
                  <i className="fas fa-quote-right"></i>
                </div>
                
                {/* Category Badge */}
                {testimonial.category && (
                  <div style={{ marginBottom: '1rem' }}>
                    <span style={{
                      background: `${getCategoryColor(testimonial.category)}15`,
                      padding: '0.25rem 0.75rem',
                      borderRadius: '20px',
                      fontSize: '0.7rem',
                      color: getCategoryColor(testimonial.category),
                      fontWeight: 600,
                      display: 'inline-block'
                    }}>
                      {testimonial.category}
                    </span>
                  </div>
                )}
                
                {/* Rating Stars */}
                <div style={{ marginBottom: '1rem' }}>
                  {renderStars(testimonial.rating || 5)}
                </div>
                
                {/* Testimonial Content */}
                <p style={{
                  fontSize: '0.95rem',
                  lineHeight: '1.6',
                  color: '#1E293B',
                  marginBottom: '1.5rem',
                  position: 'relative',
                  zIndex: 1,
                  flex: 1,
                  fontStyle: 'italic'
                }}>
                  "{testimonial.content || testimonial.text}"
                </p>
                
                {/* Author Info */}
                <div style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '1rem',
                  marginTop: '1rem',
                  paddingTop: '1rem',
                  borderTop: '1px solid #E2E8F0'
                }}>
                  {/* Avatar */}
                  {testimonial.avatar ? (
                    <img 
                      src={getFullImageUrl(testimonial.avatar)} 
                      alt={testimonial.name}
                      style={{
                        width: '55px',
                        height: '55px',
                        borderRadius: '50%',
                        objectFit: 'cover',
                        border: '2px solid #2C7A7B'
                      }}
                      onError={(e) => {
                        e.target.style.display = 'none';
                        e.target.parentElement.innerHTML = `
                          <div style="width: 55px; height: 55px; background: linear-gradient(135deg, #2C7A7B 0%, #4A9D9E 100%); border-radius: 50%; display: flex; align-items: center; justify-content: center; font-size: 1.5rem; color: white;">
                            ${getInitials(testimonial.name)}
                          </div>
                        `;
                      }}
                    />
                  ) : (
                    <div style={{
                      width: '55px',
                      height: '55px',
                      background: 'linear-gradient(135deg, #2C7A7B 0%, #4A9D9E 100%)',
                      borderRadius: '50%',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      fontSize: '1.5rem',
                      color: 'white'
                    }}>
                      {getInitials(testimonial.name)}
                    </div>
                  )}
                  
                  <div style={{ flex: 1 }}>
                    <div style={{ fontWeight: 700, color: '#0A192F', fontSize: '1rem' }}>
                      {testimonial.name}
                    </div>
                    <div style={{ fontSize: '0.75rem', color: '#2C7A7B', fontWeight: 500 }}>
                      {testimonial.position}
                    </div>
                    {testimonial.company && (
                      <div style={{ fontSize: '0.7rem', color: '#5A6E7F' }}>
                        {testimonial.company}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
        
        {/* Stats Section */}
        <div style={{
          display: 'flex',
          justifyContent: 'center',
          gap: 'clamp(1rem, 5vw, 3rem)',
          marginTop: '4rem',
          paddingTop: '2rem',
          borderTop: '1px solid #E2E8F0',
          flexWrap: 'wrap'
        }}>
          <div style={{ textAlign: 'center' }}>
            <div style={{ fontSize: 'clamp(1.5rem, 5vw, 2.2rem)', fontWeight: 800, color: '#2C7A7B' }}>
              {stats.satisfaction}
            </div>
            <div style={{ fontSize: '0.85rem', color: '#5A6E7F' }}>Client Satisfaction</div>
          </div>
          <div style={{ textAlign: 'center' }}>
            <div style={{ fontSize: 'clamp(1.5rem, 5vw, 2.2rem)', fontWeight: 800, color: '#2C7A7B' }}>
              {stats.projects}
            </div>
            <div style={{ fontSize: '0.85rem', color: '#5A6E7F' }}>Projects Completed</div>
          </div>
          <div style={{ textAlign: 'center' }}>
            <div style={{ fontSize: 'clamp(1.5rem, 5vw, 2.2rem)', fontWeight: 800, color: '#2C7A7B' }}>
              {stats.continents}
            </div>
            <div style={{ fontSize: '0.85rem', color: '#5A6E7F' }}>Continents Served</div>
          </div>
          <div style={{ textAlign: 'center' }}>
            <div style={{ fontSize: 'clamp(1.5rem, 5vw, 2.2rem)', fontWeight: 800, color: '#2C7A7B' }}>
              {stats.repeatBusiness}
            </div>
            <div style={{ fontSize: '0.85rem', color: '#5A6E7F' }}>Repeat Business</div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;